import { Component, OnInit } 									from '@angular/core';
import {FormControl, FormGroupDirective, NgForm, Validators} 	from '@angular/forms';
import {ErrorStateMatcher} 										from '@angular/material/core';

import { Router, ActivatedRoute } 								from '@angular/router';
import { first } 												from 'rxjs/operators';

import { AlertService, AuthenticationService } 					from '../_services';
import { Globals}                                               from '../_helpers';

import { NgxSpinnerService }                                    from 'ngx-spinner';

export class MyErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
	    const isSubmitted = form && form.submitted;
	    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
	}
}


@Component({
  selector: 'auth-login',
  templateUrl: './auth.component.html'
})


export class AuthComponent implements OnInit {
	usernameFormControl = new FormControl('', [
	    Validators.required,
	]);
	passwordFormControl = new FormControl('', [
	    Validators.required,
	]);
  	matcher = new MyErrorStateMatcher();

    loading = false;
    submitted = false;
    isErrorLogin = false;
    errorMsg : string;
    returnUrl: string;
    resetMsg : string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService

    ) {}


    ngOnInit() {
        var username = atob(this.route.snapshot.paramMap.get("username"));
        var user_id = atob(this.route.snapshot.paramMap.get("user_id"));
        if(username != ''){
            this.usernameFormControl.setValue(username);
            this.passwordFormControl.setValue('');
        }
        else{
           this.router.navigateByUrl('/login'); 
        }
    }

    public onSubmit() {
        this.submitted = true;

        /* stop here if form is invalid */
        if (this.usernameFormControl.value == '' || this.passwordFormControl.value == '') {
            this.isErrorLogin = false;
            return false;
        }
        else{
            this.loading = true;
            this.spinner.show();
            this.authenticationService.authLogin(this.globals.root_url, this.usernameFormControl.value, this.passwordFormControl.value)
            .pipe(first())
            .subscribe(
    	        data => {
                    if(data.code == 1000){
                        this.isErrorLogin = false;
                        localStorage.setItem('currentUser', JSON.stringify({id:data.id, usercode:data.usercode, is_proctoring:data.is_proctoring, is_report:data.is_report}));
                        this.router.navigateByUrl('/dashboard');
                    }
                    else{
                        this.isErrorLogin = true;
                        this.errorMsg = 'Invalid username or password !!';
                        this.loading = false;
                    }
                    this.spinner.hide();
    	        },
    	        error => {
                    this.isErrorLogin = true;
                    this.errorMsg = 'Invalid username or password !!';
    	            this.alertService.error(error);
    	            this.loading = false;
                    this.spinner.hide();
    	        }
    	    );
        }
    }
}

